"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getColorBackground = void 0;
const getColorBackground = (param)=>{
    let { hexColors, imageUrl, theme } = param;
    if ((hexColors === null || hexColors === void 0 ? void 0 : hexColors.length) === 1 && hexColors[0]) {
        return hexColors[0];
    }
    if (hexColors && hexColors.length > 1) {
        return "linear-gradient(to right, ".concat(hexColors[0], ", ").concat(hexColors[0], " 50%, ").concat(hexColors[1], " 50%)");
    }
    if (imageUrl) {
        return "url(".concat(imageUrl, ")");
    }
    return theme.palette.common.white;
};
exports.getColorBackground = getColorBackground;
